// extracted by mini-css-extract-plugin
export default {"container":"CalendarSync_container__QREj1","description":"CalendarSync_description__UMUUl","state":"CalendarSync_state__rRgJF"};